/**
 * Validates a single field in the Order Details Opportunity form.
 * @param {string} name - Field name
 * @param {string} value - Field value
 * @returns {string|null} - Error message or null if valid
 */
export const validateOrderOpportunityField = (name, value) => {
  if (name === "newMedication") {
    if (!value) return "Please specify if this is a new medication";
  }
  
  return null;
};

/**
 * Validates the entire Order Details Opportunity form data.
 * @param {object} data - Order details opportunity data
 * @returns {object} - Object containing errors for each field
 */
export const validateOrderOpportunityForm = (data) => {
  const errors = {};
  const fields = ["newMedication"];
  
  fields.forEach(field => {
    const error = validateOrderOpportunityField(field, data[field]);
    if (error) errors[field] = error;
  });
  
  return errors;
};
